import { styled } from '@linaria/react'
import { FIXED_INDENTS, LAYOUT, MEDIA, ROW_GAP } from 'vars/index'
import { SearchHintSC } from './SearchHint/SearchHint.styled'

export const HintsCarouselControlSC = styled.div`
  height: 100%;
`

export const HintsCarouselWrapperSC = styled.div`
  position: relative;

  > ${HintsCarouselControlSC} {
    display: none;

    ${MEDIA.NO_TOUCH} {
      height: fit-content;
      display: inline-flex;
      position: absolute;
      z-index: 3;
      top: 50%;
      transform: translateY(-50%);

      &:first-child {
        left: var(${FIXED_INDENTS.INDENT_40});
      }

      &:last-child {
        right: var(${FIXED_INDENTS.INDENT_40});
      }
    }
  }
`

export const HintsScrollableRowSC = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  scroll-behavior: smooth;
  padding: 0 var(${LAYOUT.HorizontalPaddings});

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;

  display: flex;
  align-items: center;
  gap: var(${ROW_GAP.SIZE_30});

  > ${SearchHintSC} {
    scroll-margin-left: var(${LAYOUT.HorizontalPaddings});
    flex: 0 0 auto;
    scroll-snap-align: start;
  }

  scroll-snap-type: x proximity;

  ${MEDIA.TOUCH} {
    scroll-snap-type: x mandatory;
  }
`

export const HintsContainerSC = styled.div`
  width: 100%;
`
